import { render, staticRenderFns } from "./internReferralView.vue?vue&type=template&id=dc8e22f4&scoped=true"
import script from "./internReferralView.vue?vue&type=script&lang=js"
export * from "./internReferralView.vue?vue&type=script&lang=js"
import style0 from "./internReferralView.vue?vue&type=style&index=0&id=dc8e22f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8e22f4",
  null
  
)

export default component.exports